import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {AppBar, Button, Toolbar,} from '@material-ui/core';
import {Link} from "react-router-dom";

const styles = {
  root:{
    backgroundColor: '#003e58',
    color: 'white'
  },
  toolbar:{
    gap:'1em',
    padding:'0'
  },
  nav: {
    maxWidth: 'fit-content',
    height:'64px',
    padding: '6px 1rem',
    opacity: 1,
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.3)'
    }
  },
  logoButton: {
    minWidth: 'fit-content',
    height:'64px',
    maxHeight: '64px',
    boxSizing:'border-box',
    padding: '8px 1rem',
    marginRight: 'auto',
    alignSelf: 'center',
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.3)'
    }
  },
  logoImage: {
    height:'46px',
    alignSelf: 'center'
  }
}

function ExternalAppBar(props) {
  const {classes} = props;

  return (
    <AppBar position='static' className={classes.root}>
      <Toolbar className={classes.toolbar}>
        <Button color='inherit' className={classes.logoButton} component="a" href="/">
          <img alt="LifeNaut" src="/v2/images/lifenaut-logo-dark-trans.png" className={classes.logoImage}/>
        </Button>
        <Button color='inherit' className={classes.nav} component={Link} to="/signup">Signup</Button>
        <Button color='inherit' className={classes.nav} component={Link} to="/">Login</Button>
      </Toolbar>
    </AppBar>
  );
}

export default withStyles(styles)(ExternalAppBar);
